/* STATE */
import { combineReducers } from 'redux';

import { createActionCreator, createReducer, RequestActionTypes } from 'helpers/redux/reduxHelpers';
import { AppState } from 'helpers/store/models/AppState';
import { AuthActionTypes } from 'saga/auth/ducks';

export interface ContextOnlinePaymentData {
  paymentId: number;
  amount: number;
}

export interface ContextOnlinePaymentState {
  data?: ContextOnlinePaymentData | null;
}

/* ACTION TYPES */
export enum ContextOnlinePaymentActionTypes {
  SetContextOnlinePaymentData = '@@Context/OnlinePayment/SET_CONTEXT_ONLINE_PAYMENT_DATA',
}

/* ACTIONS */
export const setContextOnlinePaymentDataAction = createActionCreator(
  ContextOnlinePaymentActionTypes.SetContextOnlinePaymentData
);

/* REDUCERS */
const initialState: ContextOnlinePaymentState = { data: null };

const data = createReducer(initialState.data, {
  [ContextOnlinePaymentActionTypes.SetContextOnlinePaymentData]: (
    _state: ContextOnlinePaymentData,
    payload: ContextOnlinePaymentData
  ) => payload,
  [AuthActionTypes.Logout]: {
    [RequestActionTypes.SUCCESS]: () => null,
  },
});

export default combineReducers<ContextOnlinePaymentState>({ data });

/* SELECTORS */
const selectContextOnlinePayment = (state: AppState) => state.context.onlinePaymentData || {};

export const selectContextOnlinePaymentData = (state: AppState): ContextOnlinePaymentData | null | undefined =>
  selectContextOnlinePayment(state).data;
